import actionTypes from "./actionTypes";

export const fetchFieldsAction = (data, fetchFn) => {
  return {
    type: actionTypes.FETCH_FIELDS,
    payload: data,
    meta: { fetchFn }
  };
};

export const showFieldsLoader = data => {
  return {
    type: actionTypes.SHOW_FIELDS_LOADER,
    payload: data
  };
};

export const hideFieldsLoader = data => {
  return {
    type: actionTypes.HIDE_FIELDS_LOADER,
    payload: data
  };
};

export const showNextSection = data => {
  return {
    type: actionTypes.SHOW_NEXT_SECTION,
    payload: data
  };
};

export const hideNextSection = data => {
  return {
    type: actionTypes.HIDE_NEXT_SECTION,
    payload: data
  };
};

export const setSectionMessage = data => {
  return {
    type: actionTypes.SECTION_MESSAGE,
    payload: data
  };
};

export const addMiscFee = data => {
  return {
    type: actionTypes.ADD_MISC_FEE,
    payload: data
  };
};

export const setMiscFeeValue = data => {
  return {
    type: actionTypes.SET_MISC_FEE_VALUE,
    payload: data
  };
};

export const setPre1981DataValue = data => {
    return {
        type: actionTypes.SET_PRE1981DATA_VALUE,
        payload: data
    };
};

export const sanitizeFieldsAction = response => {
  return {
    type: actionTypes.SANITIZE_FIELDS,
    payload: response
  };
};

export const fetchFieldsSuccessAction = data => {
  return {
    type: actionTypes.FETCH_FIELDS_SUCCESS,
    payload: data
  };
};

export const fetchFieldsFailedAction = err => {
  return {
    type: actionTypes.FETCH_FIELDS_FAILED,
    payload: err.message,
    error: true
  };
};

export const requestChangeInputValueAction = (name, value, field) => {
  return {
    type: actionTypes.REQUEST_CHANGE_INPUT_VALUE,
    payload: { name, value, field }
  };
};

export const changeInputValueAction = (name, value, field) => {
  return {
    type: actionTypes.CHANGE_INPUT_VALUE,
    payload: { name, value, field }
  };
};

export const createWorkItemAction = (fieldDetails, status, redirect = true) => {
  return {
    type: actionTypes.CREATE_WORK_ITEM,
    payload: { fieldDetails, status },
    redirect
  };
};

export const createWorkItemSuccessAction = workItem => {
  return {
    type: actionTypes.CREATE_WORK_ITEM_SUCCESS,
    payload: workItem
  };
};

export const createWorkItemFailedAction = err => {
  return {
    type: actionTypes.CREATE_WORK_ITEM_FAILED,
    payload: err
  };
};

export const cancelWorkItemAction = () => {
  return {
    type: actionTypes.CANCEL_WORKITEM
  };
};

export const generateWorkItemReportAction = workItem => {
  return {
    type: actionTypes.GENERATE_WORKITEM_REPORT,
    payload: workItem
  };
};

export const generateWorkItemReportSuccessAction = workItem => {
  return {
    type: actionTypes.GENERATE_WORKITEM_REPORT_SUCCESS,
    payload: workItem
  };
};

export const generateWorkItemReportFailedAction = err => {
  return {
    type: actionTypes.GENERATE_WORKITEM_REPORT_FAILED,
    payload: err
  };
};

export const workItemReportInProgressAction = workItem => {
  return {
    type: actionTypes.WORKITEM_REPORT_IN_PROGRESS,
    payload: workItem
  };
};

export const changeStateCloneWorkItem = (state, workitemId) => {
  return{
    type: actionTypes.CHANGE_STATE_CLONE_WORKITEM,
    state: state,
    workitemId: workitemId
  }
}

export const enableQuestionaireButtons = () => {
    return {
        type: actionTypes.ENEABLE_QUESTIONAIRE_BUTTONS
    };
};

